import { AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Validate date from form input to check whether the day is a valid date before sending to backend.
 */
export function dateValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;

    const match = /^([0-9]{1,2})[./]([0-9]{1,2})[./]([0-9]{4})$/.exec(value);
    if (!match) return { invalidFormat: true };

    const day = Number(match[1]);
    const month = Number(match[2]);
    const year = Number(match[3]);

    if (isNaN(day) || isNaN(month) || isNaN(year) || day < 1 || day > 31 || month < 1 || month > 12) {
        return { invalidDate: true };
    }

    // Construct date and check for overflow (e.g., Feb 30)
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
        return { invalidDate: true };
    }

    // Check for future date
    const now = new Date();
    now.setHours(23, 59, 59, 999); // End of today
    if (date > now) return { futureDate: true };

    // Check if date is older than one year
    const oneYearAgo = new Date();
    oneYearAgo.setHours(23, 59, 59, 999); // End of one year ago
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
    if (date < oneYearAgo) return { exceededOneYear: true };

    return null;
}
